module.exports = __webpack_public_path__ + "img/5right-19958dc0.png";